import { gql } from '@apollo/client';

export const getTimepointsForDisclaimingQuery = gql`
  query getTimepointsForDisclaiming($territoryId: ID!) {
    getTimepointsForDisclaiming(territoryId: $territoryId) {
      timePoints
    }
  }
`;
